import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  customFieldsAsync,
  customFieldsStartReducer,
} from "../../_redux/_services/UserManagerSlice";
import { defaultApplicantsData } from "../../_utilities/defaultfieldsModel";
import ApplicantsDynamicTable from "../../components/DynamicTable/ApplicantsDynamicTable";

import * as _info from "../../_utilities/getUserInfo";
import { normalizeValue, safeJsonParse } from "../../_utilities/utilities";
import { safeJSONParse } from "../../_utilities/constants";
const ApplicantsComponent = ({
  componentType,
  input,
  iniValue,
  actions,
  onValidData,
  disableSubmitBtn,
}) => {
  const [getDetails, setGetDetails] = useState(iniValue);
  const [addSkills, setAddSkills] = useState("");
  const [addCertification, setAddCertification] = useState("");
  const [disableBtn, setDisableBtn] = useState(disableSubmitBtn);
  const [GetUserId, setUserId] = useState(null);
  const [isPortals, setIsPortals] = useState(false);
  const [portalFrom, setPortalFrom] = useState("");
  // defaultDropdownOptionValues
  const [sourceModelValues, setSourceModelValues] = useState([]);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);

  // customFields
  const [customFieldsArray, setCustomFieldsArray] = useState([]);
  const [getcustomFields, setGetCustomFields] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    async function init() {
      const userId = await _info.GetUserId();
      setUserId(userId);
    }
    init();
  }, []);

  useEffect(() => {
    if (JSON.stringify(input) === JSON.stringify(iniValue)) {
      formik.resetForm();
    }
    if (
      input !== undefined &&
      input !== null &&
      customFieldsData &&
      customFieldsData.length > 0
    ) {
      //&& input.Applicants.firstName !== ""
      if (typeof input.skillDetails === "string") {
        input.skillDetails = JSON.parse(input.skillDetails);
      }
      formik.values.firstName = input.Applicants.firstName
        ? input.Applicants.firstName
        : "";
      formik.values.lastName = input.Applicants.lastName
        ? input.Applicants.lastName
        : "";
      formik.values.contactNumber = input.Applicants.contactNumber
        ? input.Applicants.contactNumber
        : "";
      formik.values.emailId = input.Applicants.emailId
        ? input.Applicants.emailId
        : "";
      formik.values.linkedIn = input.linkedIn ? input.linkedIn : "";
      formik.values.resumesourceId = input.Applicants.resumesourceId
        ? input.Applicants.resumesourceId
        : "";
      formik.values.candidateStatus = input.Applicants.candidateStatus
        ? input.Applicants.candidateStatus
        : "";
      formik.values.totalExperience = input.Applicants.totalExperience
        ? input.Applicants.totalExperience
        : "";

      // for customfields
      if (customFieldsData && customFieldsData.length > 0) {
        const data = JSON.parse(JSON.stringify(customFieldsData));
        let customPostingFieldsData = data.filter(
          (x) => x.moduleId.toString() === "2" && x.fieldType === "custom",
        );

        if (componentType !== "Create" && input.customFields) {
          let customFieldsData = safeJSONParse(JSON.parse(input.customFields));
          let formatCustomFields = {};
          if (customFieldsData && customFieldsData.length > 0) {
            customFieldsData.forEach((list) => {
              if (customPostingFieldsData?.length > 0) {
                customPostingFieldsData?.forEach((item) => {
                  if (item.fieldName === list.key) {
                    if (item.dataType.toLowerCase().trim() !== "text box") {
                      if (
                        item.dataType.toLowerCase().trim() === "single select"
                      ) {
                        if (typeof list.value === "string") {
                          formatCustomFields[list.key] = list.value;
                        } else {
                          const commonValues = JSON.parse(
                            item.customValues,
                          ).filter((value) => {
                            const valStr = (list.value ?? "").toString();
                            return valStr.includes(value);
                          });
                          formatCustomFields[list.key] =
                            commonValues.length > 0 ? commonValues[0] : [];
                        }
                      } else {
                        if (typeof list.value === "string") {
                          formatCustomFields[list.key] = JSON.parse(
                            item.customValues,
                          ).includes(list.value)
                            ? [list.value]
                            : [];
                        } else {
                          const commonValues = JSON.parse(
                            item.customValues,
                          ).filter((value) => {
                            if (Array.isArray(list.value)) {
                              return list.value.includes(value);
                            }
                            if (typeof list.value === "string") {
                              return list.value.includes(value);
                            }
                            return false;
                          });
                          formatCustomFields[list.key] =
                            commonValues.length > 0 ? commonValues : [];
                        }
                      }
                    } else {
                      formatCustomFields[list.key] = list.value;
                    }
                  }
                });
              } else {
                formatCustomFields[list.key] = list.value; // (typeof list.value === 'string') ? [list.value] :
              }
            });
            console.log("formatCustomFields +++++++", formatCustomFields);
            setGetCustomFields(formatCustomFields);
          }
        }
      }
      if (
        input.source === "Job Board Portal" ||
        input.source === "Cloud Sourcing" ||
        input.source === "Employee Portal" ||
        input.source === "Vendor Sourcing"
      ) {
        setIsPortals(true);
        formik.values.resumesourceId = "10";
        input.Applicants.resumesourceId = "10";
        setPortalFrom(input.source);
      }
      input.certification = safeJsonParse(input.certification);
      setGetDetails(input);
      setDisableBtn(false);
    }
    // else if (GetUserId()) {
    //   dispatch(customFieldsAsync(GetUserId()));
    // }
    // eslint-disable-next-line
  }, [input, iniValue, customFieldsData]);

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Source") {
          setSourceModelValues(list.customValues);
        } else if (list.fieldName === "Candidate status") {
          setCandidateStatusValues(list.customValues);
        }
      });
    }
  }, []);

  // useEffect(() => {
  //   if (GetUserId === null) {
  //     let userId = GetUserId()
  //     setUserId(userId);
  //     dispatch(customFieldsAsync(userId));
  //   }
  // }, [GetUserId]);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "2" && x.fieldType === "custom",
      );
      if (customPostingFieldsData.length > 0) {
        let Array = {};
        customPostingFieldsData.forEach((item) => {
          item.customValues = JSON.parse(item.customValues);
          item.moduleId = item.moduleId.toString();
          // item.customValues = (item.dataType.toLowerCase() !== "textbox") ? [] : '';
          Array[item.fieldName] =
            item.dataType.toLowerCase() !== "text box" ? [] : "";
        });
        setCustomFieldsArray(customPostingFieldsData);
        if (componentType !== "view") {
          setGetCustomFields(Array);
        }
      }
      let overrideDefaultPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "2" && x.fieldType === "default",
      );
      if (overrideDefaultPostingFieldsData.length > 0) {
        overrideDefaultPostingFieldsData.forEach((list) => {
          if (list.fieldName === "Source") {
            let updatedCustomValues = JSON.parse(list.customValues);
            let modifiedCustomValues = [];
            updatedCustomValues.forEach((list) => {
              if (
                list !== "Cloud Sourcing" &&
                list !== "Employee Portal" &&
                list !== "Vendor Sourcing" &&
                list !== "Job Board Portal"
              ) {
                modifiedCustomValues.push(list);
              }
            });
            setSourceModelValues(modifiedCustomValues);
          }
          if (list.fieldName === "Candidate status") {
            setCandidateStatusValues(JSON.parse(list.customValues));
          }
        });
      }
      // dispatch(customFieldsStartReducer({}))
    }
  }, [customFieldsData]);

  const onChangeHandler = (data, type) => {
    let details = JSON.parse(JSON.stringify(getDetails));
    if (type === "emailId") {
      details.Applicants[type] = data.trim();
      formik.values[type] = data.trim();
    } else {
      if (type === "contactNumber" || type === "alternateContactNumber") {
        details.Applicants[type] = data.trimStart();
        formik.values[type] = data.trimStart();
      } else if (type === "totalExperience") {
        details[type] = data.trimStart();
        formik.values[type] = data.trimStart();
      } else if (type === "linkedIn") {
        details[type] = data.trim();
        formik.values[type] = data.trim();
      } else if (type === "resumesourceId") {
        details.Applicants["resumesource"] =
          sourceModelValues[parseInt(data) - 1];
        details.Applicants[type] = data.trimStart();
        formik.values[type] = data.trimStart();
      } else if (type === "formattedLocation" || type === "locationCity" || type === "locationCountry" || type === "locationState" || type === "latitude" || type === "longitude") {
        details[type] = data.trimStart();
        formik.values[type] = data.trimStart();
      } else {
        details.Applicants[type] = data.trimStart();
        formik.values[type] = data.trimStart();
      }
    }
    setGetDetails(details);
  };

  useEffect(() => {
    console.log("getDetails", getDetails);
  }, [getDetails]);

  const onChangeCustomFieldsHandler = (value, type) => {
    console.log("getcustomFields >>>>>>>>>>>", getcustomFields);
    setGetCustomFields((prevousValue) => ({ ...prevousValue, [type]: value }));
  };

  useEffect(() => {
    console.log("getcustomFields >>>>>>>>>>>", getcustomFields);
  }, [getcustomFields]);

  const onTableData = (data, type) => {
    let Array = JSON.parse(JSON.stringify(getDetails));
    Array[type] = data;
    setGetDetails(Array);
  };

  const onRemoveHandler = (item, index, type) => {
    let details = JSON.parse(JSON.stringify(getDetails));
    details[type].splice(index, 1);
    setGetDetails(details);
  };

  const phoneRegExp =
    // /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
    /^[0-9()+-\s\b]*$/;

  // /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .trim()
      .matches(/^[A-Za-z ]*$/, "Please enter valid name")
      .min(1, "must be 1 characters")
      .max(50, "must be less than 50")
      .required("Please enter first name"),
    lastName: Yup.string()
      .trim()
      .matches(/^[A-Za-z ]*$/, "Please enter valid name")
      .min(1, "must be 1 characters")
      .max(50, "must be less than 50")
      .required("Please enter last name"),
    contactNumber: Yup.string()
      .matches(
        phoneRegExp,
        "Invalid contact number format. Please enter a valid number",
      )
      .min(10, "must be 10 characters")
      .max(20, "must be less than 20")
      .required("Please enter contact number"),
    alternateContactNumber: Yup.string()
      .matches(
        phoneRegExp,
        "Invalid alternate contact number format. Please enter a valid number",
      )
      .min(10, "must be 10 characters")
      .max(20, "must be less than 20"),
    emailId: Yup.string()
      .email("Please enter a valid E-mail address")
      .matches(
        /^[a-zA-Z0-9_!#$%&*+/=?`{}~^.-]+@[a-zA-Z0-9.-]+$/,
        "Invalid E-mail address format. Please enter a valid E-mail",
      )
      .required("Please enter a E-mail address"),
    resumesourceId: Yup.string()
      .trim()
      .min(1, "must be 1 characters")
      .max(20, "must be less than 20")
      .required("Please select a source from the dropdown"),
    candidateStatus: Yup.string().required(
      "Please select Candidate's status from the dropdown",
    ),
    totalExperience: Yup.string().matches(
      /^[0-9\b]+$/,
      "Please enter a valid number",
    ),
    linkedIn: Yup.string().matches(
      /^(https?:\/\/)?(www\.|\w{2}\.)?linkedin\.com\/(in|company)\/[a-zA-Z0-9_-]+\/?$/,
      "Please enter a valid LinkedIn URL",
    ),
    formattedLocation: Yup.string().matches(
      /^[a-zA-Z0-9\s,#.&/-]*$/,
      "Please enter a valid address",
    ),
    locationCity: Yup.string().matches(/^[A-Za-z ]*$/,"Please enter valid city name"),
    locationCountry: Yup.string().matches(/^[A-Za-z ]*$/,"Please enter valid country name"),
    locationState: Yup.string().matches(/^[A-Za-z ]*$/,"Please enter valid state name"),
    latitude: Yup.number()
      .typeError("Latitude must be a number")
      .min(-90, "Latitude must be between -90 and 90")
      .max(90, "Latitude must be between -90 and 90"),
    longitude: Yup.number()
      .typeError("Longitude must be a number")
      .min(-180, "Longitude must be between -180 and 180")
      .max(180, "Longitude must be between -180 and 180"),
  });

  // Build errors for mandatory custom fields
  const validateMandatoryCustomFields = (fieldsArray = [], valuesObj = {}) => {
    const cfErrors = {};
    fieldsArray.forEach((f) => {
      if (Number(f.mandatory) !== 1) return; // only required
      const key = f.fieldName;
      const dt = (f.dataType || "").toLowerCase().trim();
      const v = valuesObj[key];

      if (dt === "text box") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "single select") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "multi select") {
        if (!Array.isArray(v) || v.length === 0)
          cfErrors[key] = "Select at least one option";
      }
    });
    return cfErrors;
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      contactNumber: "",
      emailId: "",
      source: 0,
      resumesourceId: "",
      candidateStatus: "",
    },
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    validate: (values) => {
      const errors = {};
      values.candidateStatus = values.candidateStatus
        ? values.candidateStatus
        : getDetails?.Applicants?.candidateStatus ||
          candidateStatusValues[0]?.internal;
      values.source = values.source !== 0 ? values.source : "ATS";
      console.log("values", values);
      // uses latest customFieldsArray + getcustomFields from this render
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray,
        getcustomFields,
      );
      if (Object.keys(cfErrors).length) {
        errors.customFields = cfErrors;
      }
      return errors;
    },
    onSubmit: async (values) => {
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray,
        getcustomFields,
      );
      if (Object.keys(cfErrors).length > 0) {
        const element = document.querySelector(".personaldetails");
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        }
        formik.setErrors((prev) => ({
          ...(prev || {}),
          customFields: cfErrors,
        }));
        formik.setTouched(
          (prev) => ({
            ...(prev || {}),
            customFields: Object.fromEntries(
              Object.keys(cfErrors).map((k) => [k, true]),
            ),
          }),
          true,
        );
        return;
      }
      let ArrayOfCustomFields = [];
      if (getcustomFields !== null) {
        let keys = Object.keys(getcustomFields);
        keys.forEach((items, i) => {
          let obj = { key: items, value: getcustomFields[items] };
          ArrayOfCustomFields.push(obj);
        });
      }
      setDisableBtn(true);
      let obj = { ...getDetails };
      obj["customFields"] = JSON.stringify(ArrayOfCustomFields);
      await onValidData(obj);
    },
  });

  useEffect(() => {
    if (
      candidateStatusValues.length > 0 &&
      input &&
      componentType === "Create"
    ) {
      let details = JSON.parse(JSON.stringify(input));
      details.Applicants.candidateStatus = candidateStatusValues[0].internal;
      setGetDetails(details);
      formik.values.candidateStatus = candidateStatusValues[0].internal;
    }
  }, [candidateStatusValues, input, componentType]);

  useEffect(() => {
    if (
      candidateStatusValues.length > 0 &&
      input &&
      !input.Applicants.candidateStatus &&
      componentType === "Edit"
    ) {
      let details = JSON.parse(JSON.stringify(input));
      details.Applicants.candidateStatus = candidateStatusValues[0].internal;
      setGetDetails(details);
      formik.values.candidateStatus = candidateStatusValues[0].internal;
    }
  }, [candidateStatusValues, input, componentType]);

  const getSelectedValue = (key) => {
    const val = getcustomFields?.[key];
    if (!val) return "";
    if (Array.isArray(val)) {
      return val[0]?.toString() || ""; // .toLowerCase()
    }
    return val.toString(); // .toLowerCase()
  };

  const clearInvalidCustomFieldValue = (fieldName, values) => {
    const currentValue = getcustomFields?.[fieldName]; // normalizeValue(getcustomFields?.[fieldName]);
    if (!currentValue) return;
    const validValues = values || []; // .map((v) => v.toLowerCase())
    if (!validValues.includes(currentValue)) {
      onChangeCustomFieldsHandler("", fieldName);
    }
  };

  const handleAddSkill = (value) => {
    const skill = value.trim();
    if (!skill) return;

    let details = JSON.parse(JSON.stringify(getDetails));

    details.skillDetails.push({
      name: skill,
      numberOfMonths: null,
      lastUsed: "",
    });

    setGetDetails(details);
    setAddSkills("");
  };
  return (
    <React.Fragment>
      {componentType !== "Create" ? (
        <div className="actionBtnRtl">
          {actions &&
            actions.map((item) => {
              if (item.type === "back") {
                return (
                  <Button
                    variant={item.variant}
                    className={item.class}
                    style={item.style}
                    onClick={() => navigate(item.navigateTo)}
                    size="small"
                  >
                    <Link
                      href="#"
                      style={{ color: "red", fontSize: "14px" }}
                      underline="always"
                    >
                      {" "}
                      {item.label}
                      {""}
                    </Link>
                  </Button>
                );
              } else if (item.type === "submit") {
                return (
                  <Button
                    variant={item.variant}
                    className={item.class}
                    disabled={disableBtn}
                    style={item.style}
                    onClick={formik.handleSubmit}
                    size="small"
                  >
                    {item.label}
                    {""}
                  </Button>
                );
              }
            })}
        </div>
      ) : (
        ""
      )}
      <FocusError formik={formik} />
      <div
        style={{ width: "98%", margin: "0 auto" }}
        className={componentType === "view" ? "viewSection" : ""}
      >
        <div style={{ width: "100%" }}>
          <div className="personaldetails">
            <img
              src={process.env.PUBLIC_URL + "/assests/img/profile.svg"}
              alt=""
            />
            <h3 className="personaldetailstext"> Personal Details </h3>
          </div>
          <div
            style={{
              display: "flex",
              flexFlow: "wrap",
              marginTop: "60px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.firstName && formik.touched.firstName
                    ? true
                    : false
                }
                helperText={
                  formik.errors.firstName && formik.touched.firstName
                    ? formik.errors.firstName
                    : ""
                }
                id="outlined-basic"
                label="First Name*&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="firstName"
                autoComplete="off"
                value={
                  getDetails.Applicants.firstName
                    ? getDetails.Applicants.firstName
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "firstName")}
                onBlur={formik.handleBlur}
              />
            </div>

            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.lastName && formik.touched.lastName
                    ? true
                    : false
                }
                helperText={
                  formik.errors.lastName && formik.touched.lastName
                    ? formik.errors.lastName
                    : ""
                }
                id="outlined-basic"
                label="Last Name*&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="lastName"
                autoComplete="off"
                value={
                  getDetails.Applicants.lastName
                    ? getDetails.Applicants.lastName
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "lastName")}
                onBlur={formik.handleBlur}
              />
            </div>

            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.contactNumber && formik.touched.contactNumber
                    ? true
                    : false
                }
                helperText={
                  formik.errors.contactNumber && formik.touched.contactNumber
                    ? formik.errors.contactNumber
                    : ""
                }
                id="outlined-basic"
                label="Contact Number*&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="contactNumber"
                autoComplete="off"
                value={
                  getDetails.Applicants.contactNumber
                    ? getDetails.Applicants.contactNumber
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) =>
                  onChangeHandler(e.target.value, "contactNumber")
                }
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "60px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.alternateContactNumber &&
                  formik.touched.alternateContactNumber
                    ? true
                    : false
                }
                helperText={
                  formik.errors.alternateContactNumber &&
                  formik.touched.alternateContactNumber
                    ? formik.errors.alternateContactNumber
                    : ""
                }
                id="outlined-basic"
                label="Alternate Contact Number&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="alternateContactNumber"
                autoComplete="off"
                // shrink={componentType !== "Create" ? true : false}
                InputLabelProps={{
                  shrink: true,
                }}
                value={
                  getDetails.Applicants.alternateContactNumber
                    ? getDetails.Applicants.alternateContactNumber
                    : ""
                }
                disabled={componentType === "view" ? true : false}
                onChange={(e) =>
                  onChangeHandler(e.target.value, "alternateContactNumber")
                }
                onBlur={formik.handleBlur}
              />
            </div>

            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.emailId && formik.touched.emailId ? true : false
                }
                helperText={
                  formik.errors.emailId && formik.touched.emailId
                    ? formik.errors.emailId
                    : ""
                }
                id="outlined-basic"
                label="E-mail Address*&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="emailId"
                autoComplete="off"
                value={
                  getDetails.Applicants.emailId
                    ? getDetails.Applicants.emailId
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "emailId")}
                onBlur={formik.handleBlur}
              />
            </div>

            <div style={{ width: "32%" }}>
              <FormControl
                fullWidth
                error={
                  formik.errors.resumesourceId && formik.touched.resumesourceId
                    ? true
                    : false
                }
              >
                <InputLabel
                  className={
                    componentType !== "Create"
                      ? "boldSelectlabelview"
                      : "boldSelectlabel"
                  }
                  shrink={true}
                >
                  Sourced From *&nbsp;
                </InputLabel>
                <Select
                  value={
                    isPortals === true
                      ? "10"
                      : getDetails.Applicants.resumesourceId
                        ? getDetails.Applicants.resumesourceId
                        : ""
                  }
                  name="Sourced From"
                  autoComplete="off"
                  label="Sourced From*"
                  disabled={
                    componentType !== "Create" || isPortals === true
                      ? true
                      : false
                  }
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "resumesourceId")
                  }
                  style={{
                    width: "100%",
                    height: "3.5rem",
                    borderRadius: "4px",
                  }}
                  onFocus={formik.handleBlur}
                >
                  {sourceModelValues.map((name, index) => (
                    <MenuItem
                      className="selectOptions"
                      key={name}
                      value={(index + 1).toString()}
                    >
                      {name}
                    </MenuItem>
                  ))}
                  {isPortals === true && (
                    <MenuItem className="selectOptions" key="10" value="10">
                      {portalFrom}
                    </MenuItem>
                  )}
                </Select>
                <FormHelperText>
                  {formik.errors.resumesourceId && formik.touched.resumesourceId
                    ? formik.errors.resumesourceId
                    : ""}
                </FormHelperText>
              </FormControl>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              marginTop: "60px",
              justifyContent: "space-between",
              // gap: "2%",
              // flexFlow: "wrap",
            }}
          >
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.totalExperience &&
                  formik.touched.totalExperience
                    ? true
                    : false
                }
                helperText={
                  formik.errors.totalExperience &&
                  formik.touched.totalExperience
                    ? formik.errors.totalExperience
                    : ""
                }
                id="outlined-basic"
                label="Total Years Of Experience&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="totalExperience"
                autoComplete="off"
                // shrink={componentType !== "Create" ? true : false}
                InputLabelProps={{
                  shrink: true,
                }}
                value={
                  getDetails.totalExperience ? getDetails.totalExperience : ""
                }
                disabled={componentType === "view" ? true : false}
                onChange={(e) =>
                  onChangeHandler(e.target.value, "totalExperience")
                }
                onBlur={formik.handleBlur}
              />
            </div>

            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.linkedIn && formik.touched.linkedIn
                    ? true
                    : false
                }
                helperText={
                  formik.errors.linkedIn && formik.touched.linkedIn
                    ? formik.errors.linkedIn
                    : ""
                }
                id="outlined-basic"
                label="LinkedIn URL&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="linkedIn"
                autoComplete="off"
                value={getDetails.linkedIn ? getDetails.linkedIn : ""}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "linkedIn")}
                onBlur={formik.handleBlur}
              />
            </div>

            {/* customFields Ui render start here */}
            {/* {customFieldsArray &&
              customFieldsArray.length > 0 &&
              customFieldsArray.map((data, index) => {
                const err = formik.errors?.customFields?.[data.fieldName];
                const touched = formik.touched?.customFields?.[data.fieldName];
                const hasError = Boolean(
                  err && (touched || formik.submitCount > 0),
                );
                const isReq = Number(data.mandatory) === 1;

                if (data.dataType.toLowerCase().trim() === "text box") {
                  return (
                    <div
                      key={data.fieldName}
                      style={{ width: "32%", marginBottom: "3.2%" }}
                    >
                      <TextField
                        className="boldlabel"
                        id={data.fieldName}
                        variant="outlined"
                        disabled={componentType === "view"}
                        autoComplete="off"
                        style={{ width: "100%" }}
                        label={
                          isReq
                            ? `${data.fieldName} *\u00A0`
                            : `${data.fieldName} \u00A0`
                        }
                        error={hasError}
                        helperText={hasError ? err : ""}
                        name={`customFields.${data.fieldName}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={getcustomFields?.[data.fieldName] ?? ""}
                        onBlur={formik.handleBlur}
                        onChange={(e) =>
                          onChangeCustomFieldsHandler(
                            e.target.value,
                            data.fieldName,
                          )
                        }
                      />
                    </div>
                  );
                } else if (
                  data.dataType.toLowerCase().trim() === "multi select"
                ) {
                  return (
                    <div
                      key={data.fieldName}
                      style={{ width: "32%", marginBottom: "3.2%" }}
                    >
                      <FormControl
                        sx={{ width: "100%" }}
                        fullWidth
                        error={hasError}
                        required={isReq}
                      >
                        <InputLabel
                          className="boldSelectlabel"
                          shrink={true}
                          id={`${data.fieldName}-label`}
                        >
                          {data.fieldName}
                        </InputLabel>
                        <Select
                          labelId={`${data.fieldName}-label`}
                          id={`${data.fieldName}-select`}
                          multiple
                          name={`customFields.${data.fieldName}`}
                          disabled={componentType === "view" ? true : false}
                          value={
                            getcustomFields && getcustomFields[data.fieldName]
                              ? getcustomFields[data.fieldName]
                              : []
                          }
                          onChange={(e) =>
                            onChangeCustomFieldsHandler(
                              e.target.value,
                              data.fieldName,
                            )
                          }
                          onFocus={formik.handleBlur}
                          input={
                            <OutlinedInput
                              id={`select-multiple-chip-${data.fieldName}`}
                              label={
                                isReq
                                  ? `${data.fieldName} *\u00A0`
                                  : `${data.fieldName} \u00A0`
                              }
                            />
                          }
                          renderValue={(selected) => (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                                maxHeight: "65px",
                                overflowX: "auto",
                              }}
                            >
                              {typeof selected !== "string" &&
                                selected.map((value) => (
                                  <Chip key={value} label={value} />
                                ))}
                            </Box>
                          )}
                        >
                          {data.customValues &&
                            data.customValues.length > 0 &&
                            data.customValues.map((name) => (
                              <MenuItem
                                className="selectOptions"
                                key={name}
                                value={name}
                              >
                                {name}
                              </MenuItem>
                            ))}
                        </Select>

                        <FormHelperText>{hasError ? err : ""}</FormHelperText>
                      </FormControl>
                    </div>
                  );
                } else if (
                  data.dataType.toLowerCase().trim() === "single select"
                ) {
                  return (
                    <div
                      key={data.fieldName}
                      style={{ width: "32%", marginBottom: "3.2%" }}
                    >
                      <FormControl fullWidth error={hasError} required={isReq}>
                        <InputLabel
                          className="boldSelectlabel"
                          id={`${data.fieldName}-label`}
                          shrink={true}
                        >
                          {data.fieldName}
                        </InputLabel>
                        <Select
                          name={`customFields.${data.fieldName}`}
                          labelId={`${data.fieldName}-label`}
                          label={
                            isReq
                              ? `${data.fieldName} *\u00A0`
                              : `${data.fieldName} \u00A0`
                          }
                          id={`${data.fieldName}-select`}
                          autoComplete="off"
                          value={getSelectedValue(data.fieldName)}
                          variant="outlined"
                          style={{
                            width: "100%",
                            height: "3.5rem",
                            borderRadius: "4px",
                          }}
                          onChange={(e) =>
                            onChangeCustomFieldsHandler(
                              e.target.value,
                              data.fieldName,
                            )
                          }
                          onBlur={formik.handleBlur}
                          disabled={componentType === "view"}
                        >
                          {clearInvalidCustomFieldValue(
                            data.fieldName,
                            data.customValues,
                          )}
                          {data.customValues &&
                            data.customValues.length > 0 &&
                            data.customValues.map((name) => (
                              <MenuItem key={name} value={name}>
                                {name}
                              </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{hasError ? err : ""}</FormHelperText>
                      </FormControl>
                    </div>
                  );
                }
              })} */}
          {/* customFields Ui render end here */}

          <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.formattedLocation && formik.touched.formattedLocation
                    ? true
                    : false
                }
                helperText={
                  formik.errors.formattedLocation && formik.touched.formattedLocation
                    ? formik.errors.formattedLocation
                    : ""
                }
                id="outlined-basic"
                label="Formatted Location&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="formattedLocation"
                autoComplete="off"
                value={getDetails.formattedLocation ? getDetails.formattedLocation : ""}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "formattedLocation")}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              marginTop: "60px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.locationCity && formik.touched.locationCity
                    ? true
                    : false
                }
                helperText={
                  formik.errors.locationCity && formik.touched.locationCity
                    ? formik.errors.locationCity
                    : ""
                }
                id="outlined-basic"
                label="City&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="locationCity"
                autoComplete="off"
                value={getDetails.locationCity ? getDetails.locationCity : ""}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "locationCity")}
                onBlur={formik.handleBlur}
              />
            </div>
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.locationState && formik.touched.locationState
                    ? true
                    : false
                }
                helperText={
                  formik.errors.locationState && formik.touched.locationState
                    ? formik.errors.locationState
                    : ""
                }
                id="outlined-basic"
                label="State&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="locationState"
                autoComplete="off"
                value={getDetails.locationState ? getDetails.locationState : ""}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "locationState")}
                onBlur={formik.handleBlur}
              />
            </div>
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.locationCountry && formik.touched.locationCountry
                    ? true
                    : false
                }
                helperText={
                  formik.errors.locationCountry && formik.touched.locationCountry
                    ? formik.errors.locationCountry
                    : ""
                }
                id="outlined-basic"
                label="Country&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="locationCountry"
                autoComplete="off"
                value={getDetails.locationCountry ? getDetails.locationCountry : ""}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "locationCountry")}
                onBlur={formik.handleBlur}
              />
            </div>

          </div>

          <div
            style={{
              display: "flex",
              marginTop: "60px",
              gap: "2%",
              flexFlow: "wrap",
            }}
          >
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.latitude && formik.touched.latitude
                    ? true
                    : false
                }
                helperText={
                  formik.errors.latitude && formik.touched.latitude
                    ? formik.errors.latitude
                    : ""
                }
                id="outlined-basic"
                label="Latitude&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="latitude"
                autoComplete="off"
                value={getDetails.latitude ? getDetails.latitude : ""}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "latitude")}
                onBlur={formik.handleBlur}
              />
            </div>
            <div style={{ width: "32%" }}>
              <TextField
                className="boldlabel"
                error={
                  formik.errors.longitude && formik.touched.longitude
                    ? true
                    : false
                }
                helperText={
                  formik.errors.longitude && formik.touched.longitude
                    ? formik.errors.longitude
                    : ""
                }
                id="outlined-basic"
                label="Longitude&nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="longitude"
                autoComplete="off"
                value={getDetails.longitude ? getDetails.longitude : ""}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={componentType === "view" ? true : false}
                onChange={(e) => onChangeHandler(e.target.value, "longitude")}
                onBlur={formik.handleBlur}
              />
            </div>

            {/* customFields Ui render start here */}
            {customFieldsArray &&
              customFieldsArray.length > 0 &&
              customFieldsArray.map((data, index) => {
                const err = formik.errors?.customFields?.[data.fieldName];
                const touched = formik.touched?.customFields?.[data.fieldName];
                const hasError = Boolean(
                  err && (touched || formik.submitCount > 0),
                );
                const isReq = Number(data.mandatory) === 1;

                if (data.dataType.toLowerCase().trim() === "text box") {
                  return (
                    <div
                      key={data.fieldName}
                      style={{ width: "32%", marginBottom: "3.2%" }}
                    >
                      <TextField
                        className="boldlabel"
                        id={data.fieldName}
                        variant="outlined"
                        disabled={componentType === "view"}
                        autoComplete="off"
                        style={{ width: "100%" }}
                        label={
                          isReq
                            ? `${data.fieldName} *\u00A0`
                            : `${data.fieldName} \u00A0`
                        }
                        error={hasError}
                        helperText={hasError ? err : ""}
                        name={`customFields.${data.fieldName}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={getcustomFields?.[data.fieldName] ?? ""}
                        onBlur={formik.handleBlur}
                        onChange={(e) =>
                          onChangeCustomFieldsHandler(
                            e.target.value,
                            data.fieldName,
                          )
                        }
                      />
                    </div>
                  );
                } else if (
                  data.dataType.toLowerCase().trim() === "multi select"
                ) {
                  return (
                    <div
                      key={data.fieldName}
                      style={{ width: "32%", marginBottom: "3.2%" }}
                    >
                      <FormControl
                        sx={{ width: "100%" }}
                        fullWidth
                        error={hasError}
                        required={isReq}
                      >
                        <InputLabel
                          className="boldSelectlabel"
                          shrink={true}
                          id={`${data.fieldName}-label`}
                        >
                          {data.fieldName}
                        </InputLabel>
                        <Select
                          labelId={`${data.fieldName}-label`}
                          id={`${data.fieldName}-select`}
                          multiple
                          name={`customFields.${data.fieldName}`}
                          disabled={componentType === "view" ? true : false}
                          value={
                            getcustomFields && getcustomFields[data.fieldName]
                              ? getcustomFields[data.fieldName]
                              : []
                          }
                          onChange={(e) =>
                            onChangeCustomFieldsHandler(
                              e.target.value,
                              data.fieldName,
                            )
                          }
                          onFocus={formik.handleBlur}
                          input={
                            <OutlinedInput
                              id={`select-multiple-chip-${data.fieldName}`}
                              label={
                                isReq
                                  ? `${data.fieldName} *\u00A0`
                                  : `${data.fieldName} \u00A0`
                              }
                            />
                          }
                          renderValue={(selected) => (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                                maxHeight: "65px",
                                overflowX: "auto",
                              }}
                            >
                              {typeof selected !== "string" &&
                                selected.map((value) => (
                                  <Chip key={value} label={value} />
                                ))}
                            </Box>
                          )}
                        >
                          {data.customValues &&
                            data.customValues.length > 0 &&
                            data.customValues.map((name) => (
                              <MenuItem
                                className="selectOptions"
                                key={name}
                                value={name}
                              >
                                {name}
                              </MenuItem>
                            ))}
                        </Select>

                        <FormHelperText>{hasError ? err : ""}</FormHelperText>
                      </FormControl>
                    </div>
                  );
                } else if (
                  data.dataType.toLowerCase().trim() === "single select"
                ) {
                  return (
                    <div
                      key={data.fieldName}
                      style={{ width: "32%", marginBottom: "3.2%" }}
                    >
                      <FormControl fullWidth error={hasError} required={isReq}>
                        <InputLabel
                          className="boldSelectlabel"
                          id={`${data.fieldName}-label`}
                          shrink={true}
                        >
                          {data.fieldName}
                        </InputLabel>
                        <Select
                          name={`customFields.${data.fieldName}`}
                          labelId={`${data.fieldName}-label`}
                          label={
                            isReq
                              ? `${data.fieldName} *\u00A0`
                              : `${data.fieldName} \u00A0`
                          }
                          id={`${data.fieldName}-select`}
                          autoComplete="off"
                          value={getSelectedValue(data.fieldName)}
                          variant="outlined"
                          style={{
                            width: "100%",
                            height: "3.5rem",
                            borderRadius: "4px",
                          }}
                          onChange={(e) =>
                            onChangeCustomFieldsHandler(
                              e.target.value,
                              data.fieldName,
                            )
                          }
                          onBlur={formik.handleBlur}
                          disabled={componentType === "view"}
                        >
                          {clearInvalidCustomFieldValue(
                            data.fieldName,
                            data.customValues,
                          )}
                          {data.customValues &&
                            data.customValues.length > 0 &&
                            data.customValues.map((name) => (
                              <MenuItem key={name} value={name}>
                                {name}
                              </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{hasError ? err : ""}</FormHelperText>
                      </FormControl>
                    </div>
                  );
                }
              })}
          {/* customFields Ui render end here */}

          </div>

          <div className="educationTable">
            <p className="educationdetailstext" style={{ marginTop: 40 }}>
              {" "}
              Education Details{" "}
            </p>
            <ApplicantsDynamicTable
              componentType={componentType}
              typeofTable="educationDetails"
              columns={educationColoumn}
              data={getDetails.educationDetails}
              receiveProps={(data) => onTableData(data, "educationDetails")}
            />
          </div>
        </div>
        <div className="educationTable">
          <p className="workexperiencetext" style={{ marginTop: 40 }}>
            {" "}
            Work Experience{" "}
          </p>
          <ApplicantsDynamicTable
            componentType={componentType}
            typeofTable="workExp"
            columns={workExperiencesColoumn}
            data={getDetails.workExp}
            receiveProps={(data) => onTableData(data, "workExp")}
          />
        </div>
        <div className="additionalList">
          <div className="workexperiencetext">Skills</div>
          {componentType !== "view" && (
            <TextField
              id="outlined-basic"
              variant="outlined"
              style={{ width: "100%" }}
              name="addskills"
              placeholder="Please enter skill and press the enter button"
              value={addSkills}
              autoComplete="off"
              inputProps={{
                enterKeyHint: "enter",
              }}
              onChange={(e) => setAddSkills(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.keyCode === 13) {
                  e.preventDefault();
                  e.stopPropagation();
                  handleAddSkill(e.target.value);
                }
              }}
              onBlur={(e) => {
                handleAddSkill(e.target.value);
              }}
            />
          )}
          <ul>
            {getDetails.skillDetails &&
              getDetails.skillDetails.length > 0 &&
              getDetails.skillDetails.map((item, i) => {
                return (
                  <li key={i}>
                    {item.name}{" "}
                    {componentType !== "view" && (
                      <CloseIcon
                        onClick={() => onRemoveHandler(item, i, "skillDetails")}
                      />
                    )}
                  </li>
                );
              })}
          </ul>
          <div className="workexperiencetext">Certifications</div>
          {componentType !== "view" && (
            <TextField
              id="outlined-basic"
              variant="outlined"
              style={{ width: "100%", marginBottom: "16px" }}
              name="addCertification"
              placeholder="Please enter certification and press the enter button"
              value={addCertification}
              autoComplete="off"
              inputProps={{
                enterKeyHint: "enter",
              }}
              onChange={(e) => setAddCertification(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.keyCode === 13) {
                  e.preventDefault();
                  e.stopPropagation();
                  const certificateValue = e.target.value.trim();
                  if (certificateValue) {
                    setAddCertification("");
                    let details = JSON.parse(JSON.stringify(getDetails));
                    details.certification.push(certificateValue);
                    setGetDetails(details);
                  }
                }
              }}
            />
          )}
          {getDetails.certification &&
            getDetails.certification.length > 0 &&
            getDetails.certification.map((item, i) => {
              return (
                <p key={i}>
                  {item}{" "}
                  {componentType !== "view" && (
                    <CloseIcon
                      onClick={() => onRemoveHandler(item, i, "certification")}
                    />
                  )}
                </p>
              );
            })}
        </div>
        {componentType === "Create" ? (
          <div
            style={{
              marginLeft: "auto!important",
              width: "fit-content",
              marginTop: "40px",
              marginLeft: "auto",
            }}
          >
            {actions &&
              actions.map((item) => {
                if (item.type === "back") {
                  return (
                    <Button
                      className={item.class}
                      variant={item.variant}
                      style={item.style}
                      onClick={() => navigate(item.navigateTo)}
                      size="small"
                    >
                      <Link
                        href="#"
                        style={{ color: "red", fontSize: "14px" }}
                        underline="always"
                      >
                        {" "}
                        {item.label}{" "}
                      </Link>
                    </Button>
                  );
                } else if (item.type === "submit") {
                  return (
                    <Button
                      className={item.class}
                      variant={item.variant}
                      disabled={disableBtn}
                      style={item.style}
                      onClick={formik.handleSubmit}
                      size="small"
                    >
                      {item.label}{" "}
                    </Button>
                  );
                }
              })}
          </div>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
};

export default memo(ApplicantsComponent);

const educationColoumn = [
  { id: 1, displayName: "Degree", name: "degree" },
  { id: 2, displayName: "School", name: "organization" },
  { id: 3, displayName: "Duration", name: "duration" },
  { id: 4, displayName: "Location", name: "locationFormated" },
  { id: 5, displayName: "Action", name: "" },
];

const workExperiencesColoumn = [
  { id: 1, displayName: "Title", name: "jobTitle" },
  { id: 2, displayName: "Employer", name: "organization" },
  { id: 4, displayName: "Duration", name: "duration" },
  { id: 3, displayName: "Employment Type", name: "empType" },
  { id: 5, displayName: "Action", name: "" },
];
